import { AppPagePaths } from "App/routes/paths";
import { orchestrationPathResources } from "Pages/orchestration/Pages/orchestrationPaths";
import { RoutingRulesPaths } from "Pages/orchestration/Pages/taskRouting/Pages/paths";

export function useOrchestrationPathing() {
    return {
        campaignsBasePath: `${AppPagePaths.orchestration}/${orchestrationPathResources.campaigns}`,
        journeysBasePath: `${AppPagePaths.orchestration}/${orchestrationPathResources.journeys}`,
        ivrsBasePath: `${AppPagePaths.orchestration}/${orchestrationPathResources.ivrs}`,
        customFunctionsBasePath: `${AppPagePaths.orchestration}/${orchestrationPathResources.customFunctions}`,
        queuesBasePath: `${AppPagePaths.orchestration}/${orchestrationPathResources.routing}/${RoutingRulesPaths.queues}`,
        routingRulesBasePath: `${AppPagePaths.orchestration}/${orchestrationPathResources.routing}/${RoutingRulesPaths.rules}`,
    };
}
